(function(){
  'use strict';

  document.querySelectorAll('script[data-section-id]').forEach(initSection);

  function initSection(scriptEl){
    const sectionId = scriptEl.getAttribute('data-section-id');
    const root = document.getElementById('cr-root-' + sectionId);
    if (!root || root.dataset.ssInit) return;
    root.dataset.ssInit = '1';

    const dataEl = document.getElementById('cr-product-data-' + sectionId);
    let productData = { variants: [] };
    try { productData = JSON.parse(dataEl.textContent); } catch(e){ /* leave empty */ }

    const imagesEl = document.getElementById('cr-material-images-' + sectionId);
    let materialImages = {};
    let materialImagesReady = Promise.resolve();
    if (imagesEl){
      try {
        const raw = JSON.parse(imagesEl.textContent);
        const checks = Object.keys(raw).map(key=>{
          return new Promise(resolve=>{
            const img = new Image();
            const done = (ok)=>{ if (ok) materialImages[key] = raw[key]; resolve(); };
            img.onload = ()=>done(true);
            img.onerror = ()=>done(false);
            img.src = raw[key];
            setTimeout(()=>done(false), 4000); // don't hang forever on a slow/missing file
          });
        });
        materialImagesReady = Promise.all(checks);
      } catch(e){ /* falls back to procedural fills */ }
    }

    // uploaded icon images no longer used — icons feature removed from
    // Common Room signs per direction; kept the material-image loader above
    // since that's still used for the acrylic swatches.

    // ---- real text measurement (not a char-count estimate) — room names
    // vary a lot ("Pool" vs "Business Center"), and an average-character-
    // width guess was letting long names run past the plate edge. ----
    const measureSvg = document.createElementNS('http://www.w3.org/2000/svg','svg');
    measureSvg.setAttribute('style','position:absolute;visibility:hidden;width:0;height:0;overflow:hidden;');
    const measureText = document.createElementNS('http://www.w3.org/2000/svg','text');
    measureSvg.appendChild(measureText);
    document.body.appendChild(measureSvg);
    function measureTextWidth(text, fontSize, family, weight){
      measureText.setAttribute('font-size', fontSize);
      measureText.setAttribute('font-family', family);
      measureText.setAttribute('font-weight', weight);
      measureText.textContent = text;
      return measureText.getComputedTextLength();
    }
    function fitFontSizeByMeasurement(text, maxWidth, maxFontSize, minFontSize, family, weight){
      if (measureTextWidth(text, maxFontSize, family, weight) <= maxWidth) return maxFontSize;
      let lo = minFontSize, hi = maxFontSize, best = minFontSize;
      for (let i=0;i<14;i++){
        const mid = (lo+hi)/2;
        if (measureTextWidth(text, mid, family, weight) <= maxWidth){ best = mid; lo = mid; } else { hi = mid; }
      }
      return best;
    }

    // ---- config (Common Room signs — Fitness Center, Pool, Business Center, etc.) ----
    const SHAPES = {
      rectangle: { label:'Rectangle' },
      oval:      { label:'Oval' },
      arch:      { label:'Arch' },
      wavy:      { label:'Wavy' },
      bowed:     { label:'Bowed Edge' },
      diagonal:  { label:'Diagonal Cut' }
    };
    // Decorative treatments layered on top of whatever Shape is selected — modeled
    // after design capabilities (side stripes, offset shadows, two-tone splits,
    // banner graphics) rather than any one franchise's specific sign, and with no
    // logos — these are meant for independent hotels ordering their own design.
    const ACCENTS = {
      none:   { label:'None', needsColor:false },
      stripe: { label:'Side Stripe',        needsColor:true, incompatibleShapes:['oval'] },
      bands:  { label:'Top & Bottom Bands', needsColor:true, incompatibleShapes:['oval'] },
      shadow: { label:'Offset Shadow',      needsColor:true },
      split:  { label:'Two-Tone Split',     needsColor:true },
      banner: { label:'Banner Swoosh',      needsColor:true }
    };
    const ACCENT_COLORS = {
      charcoal: { label:'Charcoal', hex:'#2B2E33' },
      red:      { label:'Red',      hex:'#8C2F2A' },
      brass:    { label:'Brass',    hex:'#C6A05F' },
      sage:     { label:'Sage',     hex:'#6B7A5E' },
      custom:   { label:'Custom',   hex:null }
    };
    const MATERIALS = {
      standard:  { label:'1/8" Acrylic/Rowmark',              engrave:'#241D0F' },
      backplate: { label:'1/8" Acrylic/Rowmark + Backplate',  engrave:'#241D0F' }
    };
    const TYPEFACES = {
      serif: { label:'Classic Serif', family:"Georgia, 'Times New Roman', serif", weight:600 },
      sans:  { label:'Modern Sans',   family:"-apple-system, Helvetica, Arial, sans-serif", weight:700 },
      script:{ label:'Script',        family:"'Snell Roundhand', 'Brush Script MT', 'Segoe Script', cursive", weight:400, italic:false }
    };
    const SIZES = {
      small:  { label:'Small',  w:8,  h:5 },
      medium: { label:'Medium', w:10, h:6 },
      large:  { label:'Large',  w:12, h:8 }
    };
    const MOUNTINGS = {
      flush:    { label:'Flush Wall-Mount' },
      standoff: { label:'Standoff Mount' }
    };

    const HOURS_MODES = { with:{label:'With Hours'}, without:{label:'Without Hours'} };
    const ALIGNMENTS = { left:{label:'Left'}, center:{label:'Center'}, right:{label:'Right'} };

    // Common real-world shared-space signs every property tends to need —
    // a starting point, not a restriction: editing either field switches
    // that one to manual and stops future template clicks from overwriting it.
    const TEMPLATES = {
      fitnessCenter:  { label:'Fitness Center',  roomText:'Fitness Center',  roomSub:'6:00 AM \u2013 10:00 PM' },
      pool:           { label:'Pool',            roomText:'Pool',            roomSub:'6:00 AM \u2013 10:00 PM' },
      businessCenter: { label:'Business Center', roomText:'Business Center', roomSub:'Open 24 Hours' },
      breakfastRoom:  { label:'Breakfast Room',  roomText:'Breakfast Room',  roomSub:'6:00 AM \u2013 10:00 AM' },
      laundryRoom:    { label:'Laundry Room',    roomText:'Laundry Room',    roomSub:'6:00 AM \u2013 11:00 PM' },
      conferenceRoom: { label:'Conference Room', roomText:'Conference Room', roomSub:'' },
      housekeeping:   { label:'Housekeeping',    roomText:'Housekeeping',    roomSub:'' },
      vending:        { label:'Vending',         roomText:'Vending',         roomSub:'' },
      iceMachine:     { label:'Ice Machine',     roomText:'Ice Machine',     roomSub:'' },
      custom:         { label:'Start From Scratch', roomText:'', roomSub:'' }
    };

    let state = {
      mode: 'single', // 'single' | 'bulk'
      template: 'fitnessCenter',
      roomText:'Fitness Center', roomTextManual:false,
      roomSub:'6:00 AM \u2013 10:00 PM', roomSubManual:false,
      roomTextAlign:'center', roomSubAlign:'center',
      shape:'rectangle', material:'standard', typeface:'sans',
      size:'medium', mounting:'flush',
      plateColor:'#2B2E33', textColor:'#F2ECDE', textColorManual:true,
      accent:'none', accentColor:'charcoal', accentCustomColor:'#8C2F2A',
      hoursMode:'with',
      // ---- bulk order (hotels ordering many rooms at once) ----
      // Style (shape/material/color/typeface/size/mounting/accent) is always
      // shared across the whole batch — only the room number, sub-label, and
      // icons vary per sign, since that's the only thing that differs between
      // rooms in practice.
      rooms: [],
      activeRoomIndex: 0
    };
    let lastTemplate = state.template;

    // Whichever room's text/sub-label should currently render in the live
    // preview — the single-sign fields in single mode, or the room that's
    // focused/selected in the bulk rooms table.
    function getActiveRoom(){
      if (state.mode === 'bulk'){
        return state.rooms[state.activeRoomIndex] || { roomText:'', roomSub:'' };
      }
      const showHours = state.hoursMode==='with';
      return { roomText: state.roomText, roomSub: showHours ? state.roomSub : '' };
    }

    // ---- variant lookup: Option1=Size, Option2=Material, Option3=Mounting ----
    const variantMap = {};
    productData.variants.forEach(v=>{
      variantMap[v.size + '|' + v.material + '|' + v.mounting] = v;
    });

    function findVariant(){
      const key = SIZES[state.size].label + '|' + MATERIALS[state.material].label + '|' + MOUNTINGS[state.mounting].label;
      return variantMap[key] || null;
    }

    function escapeXml(s){ return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

    // ---- grade-1 braille transliteration (real dots, not decorative) ----
    // Standard 6-dot cell numbering:  1 4
    //                                 2 5
    //                                 3 6
    const BRAILLE_LETTERS = {
      a:[1], b:[1,2], c:[1,4], d:[1,4,5], e:[1,5], f:[1,2,4], g:[1,2,4,5], h:[1,2,5], i:[2,4], j:[2,4,5],
      k:[1,3], l:[1,2,3], m:[1,3,4], n:[1,3,4,5], o:[1,3,5], p:[1,2,3,4], q:[1,2,3,4,5], r:[1,2,3,5], s:[2,3,4], t:[2,3,4,5],
      u:[1,3,6], v:[1,2,3,6], w:[2,4,5,6], x:[1,3,4,6], y:[1,3,4,5,6], z:[1,3,5,6]
    };
    const BRAILLE_DIGIT_LETTER = {'1':'a','2':'b','3':'c','4':'d','5':'e','6':'f','7':'g','8':'h','9':'i','0':'j'};
    const BRAILLE_NUMBER_SIGN = [3,4,5,6];

    // digits get the number-sign cell once per run, then a/b/c... stand in for 1/2/3...;
    // letters map directly; anything else (space, punctuation) becomes a blank cell
    function textToBrailleCells(text){
      const cells = [];
      let numberMode = false;
      for (const ch of String(text||'')){
        if (/[0-9]/.test(ch)){
          if (!numberMode){ cells.push(BRAILLE_NUMBER_SIGN); numberMode = true; }
          cells.push(BRAILLE_LETTERS[BRAILLE_DIGIT_LETTER[ch]]);
        } else if (/[a-zA-Z]/.test(ch)){
          numberMode = false;
          cells.push(BRAILLE_LETTERS[ch.toLowerCase()] || []);
        } else {
          numberMode = false;
          cells.push([]);
        }
      }
      return cells;
    }
    function brailleMarkup(text, cx, cy, color, dotR, dotGap, cellGap){
      const cells = textToBrailleCells(text);
      if (!cells.length) return '';
      const cellWidth = dotGap + cellGap;
      const totalWidth = cells.length*cellWidth - cellGap;
      const positions = { 1:[0,0], 2:[0,1], 3:[0,2], 4:[1,0], 5:[1,1], 6:[1,2] };
      let x = cx - totalWidth/2, out = '';
      cells.forEach(dotsInCell=>{
        dotsInCell.forEach(d=>{
          const [col,row] = positions[d];
          out += `<circle cx="${x+col*dotGap}" cy="${cy+row*dotGap}" r="${dotR}" fill="${color}"/>`;
        });
        x += cellWidth;
      });
      return out;
    }

    // ---- WCAG contrast ratio — a practical, checkable proxy for ADA's
    // qualitative "high contrast, non-glare finish" requirement (ADA itself
    // doesn't cite this exact formula, but it's a reasonable stand-in) ----
    function hexToRgb(hex){
      hex = String(hex).replace('#','');
      if (hex.length===3) hex = hex.split('').map(c=>c+c).join('');
      const num = parseInt(hex,16);
      return [(num>>16)&255, (num>>8)&255, num&255];
    }
    function relLuminance(hex){
      const [r,g,b] = hexToRgb(hex).map(v=>{
        v/=255;
        return v<=0.03928 ? v/12.92 : Math.pow((v+0.055)/1.055,2.4);
      });
      return 0.2126*r+0.7152*g+0.0722*b;
    }
    function contrastRatio(hex1,hex2){
      const L1=relLuminance(hex1), L2=relLuminance(hex2);
      const lighter=Math.max(L1,L2), darker=Math.min(L1,L2);
      return (lighter+0.05)/(darker+0.05);
    }

    function archPathD(x,y,w,h){
      const topY = y + h*0.24;
      return `M ${x} ${y+h} L ${x} ${topY} A ${w/2} ${topY-y} 0 0 1 ${x+w} ${topY} L ${x+w} ${y+h} Z`;
    }
    function wavyPathD(x,y,w,h){
      const iw = w*0.06;
      return `M ${x+iw} ${y} L ${x+w-iw} ${y} C ${x+w-iw*2.4} ${y+h*0.3}, ${x+w-iw*2.4} ${y+h*0.7}, ${x+w-iw} ${y+h} L ${x+iw} ${y+h} C ${x+iw*2.4} ${y+h*0.7}, ${x+iw*2.4} ${y+h*0.3}, ${x+iw} ${y} Z`;
    }
    function diagonalPathD(x,y,w,h){
      const cut = Math.min(w,h)*0.22;
      return `M ${x} ${y} L ${x+w-cut} ${y} L ${x+w} ${y+cut} L ${x+w} ${y+h} L ${x} ${y+h} Z`;
    }
    function bowedPathD(x,y,w,h){
      // straight on three sides, left edge bows outward in a gentle convex curve
      const b = w*0.09;
      return `M ${x+b} ${y} Q ${x-w*0.05} ${y+h/2} ${x+b} ${y+h} L ${x+w} ${y+h} L ${x+w} ${y} Z`;
    }
    function shapeMarkup(shape, x, y, w, h, attrs, rx){
      rx = (rx===undefined) ? 6 : rx;
      switch(shape){
        case 'oval': return `<ellipse cx="${x+w/2}" cy="${y+h/2}" rx="${w/2}" ry="${h/2}" ${attrs}/>`;
        case 'arch': return `<path d="${archPathD(x,y,w,h)}" ${attrs}/>`;
        case 'wavy': return `<path d="${wavyPathD(x,y,w,h)}" ${attrs}/>`;
        case 'bowed': return `<path d="${bowedPathD(x,y,w,h)}" ${attrs}/>`;
        case 'diagonal': return `<path d="${diagonalPathD(x,y,w,h)}" ${attrs}/>`;
        default: return `<rect x="${x}" y="${y}" width="${w}" height="${h}" rx="${rx}" ${attrs}/>`;
      }
    }
    function standoffPoints(shape, x, y, w, h){
      if (shape==='oval'){
        const rx = w/2, ry = h/2;
        const cx = x+w/2, cy = y+h/2, k = 0.78;
        return [45,135,225,315].map(deg=>{
          const rad = deg*Math.PI/180;
          return [cx + rx*k*Math.cos(rad), cy + ry*k*Math.sin(rad)];
        });
      }
      const inset = (shape==='rectangle') ? 18 : Math.max(w,h)*0.09;
      return [[x+inset,y+inset],[x+w-inset,y+inset],[x+inset,y+h-inset],[x+w-inset,y+h-inset]];
    }
    // ---- accent style overlays (drawn on top of / behind the base plate) ----
    function accentColorHex(){
      return state.accentColor==='custom' ? state.accentCustomColor : ACCENT_COLORS[state.accentColor].hex;
    }
    function offsetShadowMarkup(shape, px, py, w, h, color){
      const dx = w*0.055, dy = h*0.07;
      return shapeMarkup(shape, px+dx, py+dy, w, h, `fill="${color}"`, 6);
    }
    function accentOverlayMarkup(accent, px, py, w, h, color){
      switch(accent){
        case 'stripe':
          return `<rect x="${px}" y="${py}" width="${w*0.16}" height="${h}" fill="${color}"/>`;
        case 'bands': {
          const bandH = h*0.15;
          return `<rect x="${px}" y="${py}" width="${w}" height="${bandH}" fill="${color}"/>
                  <rect x="${px}" y="${py+h-bandH}" width="${w}" height="${bandH}" fill="${color}"/>`;
        }
        case 'split':
          return `<polygon points="${px+w},${py} ${px+w},${py+h} ${px+w*0.35},${py+h}" fill="${color}"/>`;
        case 'banner': {
          const y0 = py+h*0.32, y1 = py+h*0.46;
          return `<path d="M ${px} ${y0+h*0.06} C ${px+w*0.3} ${y0-h*0.08}, ${px+w*0.7} ${y0+h*0.1}, ${px+w} ${y0-h*0.02}
                   L ${px+w} ${y1-h*0.02} C ${px+w*0.7} ${y1+h*0.1}, ${px+w*0.3} ${y1-h*0.08}, ${px} ${y1+h*0.06} Z"
                   fill="${color}" opacity="0.92"/>`;
        }
        default: return '';
      }
    }
    // Acrylic is the only material now, and it's always custom-colored — a
    // flat, slightly glossy fill rather than any of the old drawn textures.
    function materialFillDefs(uid, customColor){
      const c = customColor || '#C6A05F';
      return `<linearGradient id="fill-${uid}" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="${c}"/><stop offset="1" stop-color="${c}"/></linearGradient>`;
    }
    function shadowFilter(mounting){
      const isStandoff = mounting==='standoff';
      const dx = isStandoff?10:3, dy = isStandoff?14:4, b = isStandoff?10:3;
      return `filter:drop-shadow(${dx}px ${dy}px ${b}px rgba(0,0,0,0.45))`;
    }

    function buildChipRow(container, options, key, disableFn){
      container.innerHTML = '';
      Object.keys(options).forEach(k=>{
        const opt = options[k];
        const btn = document.createElement('button');
        btn.className = 'ss-chip';
        btn.type = 'button';
        btn.textContent = opt.label;
        if (disableFn && disableFn(k, opt)) btn.classList.add('disabled');
        if (state[key] === k) btn.classList.add('active');
        btn.addEventListener('click', ()=>{
          if (btn.classList.contains('disabled')) return;
          state[key] = k;
          render();
        });
        container.appendChild(btn);
      });
    }

    // Rebuilds the rooms table only when the row count changes (add/remove/
    // paste-import) — otherwise just refreshes values on the existing inputs,
    // guarding focused fields, so typing a room number doesn't lose focus
    // every keystroke the way a full teardown-and-rebuild would.
    function buildRoomsTable(container){
      const rows = container.querySelectorAll('.ss-room-row');
      if (rows.length !== state.rooms.length){
        container.innerHTML = '';
        state.rooms.forEach((room, i)=> container.appendChild(buildRoomRow(room, i)));
        return;
      }
      state.rooms.forEach((room, i)=>{
        const row = rows[i];
        row.classList.toggle('active', i === state.activeRoomIndex);
        const numInput = row.querySelector('.ss-room-num');
        if (document.activeElement !== numInput) numInput.value = room.roomText;
        const subInput = row.querySelector('.ss-room-sub');
        if (document.activeElement !== subInput) subInput.value = room.roomSub;
      });
    }

    function buildRoomRow(room, i){
      const row = document.createElement('div');
      row.className = 'ss-room-row' + (i===state.activeRoomIndex ? ' active' : '');

      const numInput = document.createElement('input');
      numInput.type = 'text'; numInput.className = 'ss-room-num'; numInput.maxLength = 28;
      // Common Room names ("Business Center & Conference Room") need much
      // more width than Room Number's 3-4 digit numbers, which is what the
      // shared .ss-room-num class (flex: 0 0 4.5rem) is sized for — override
      // it here rather than in the shared CSS, so Room Number's field stays
      // narrow as intended.
      numInput.style.flex = '1 1 220px';
      numInput.placeholder = 'Room name'; numInput.value = room.roomText;
      numInput.addEventListener('input', e=>{ room.roomText = e.target.value; render(); });
      numInput.addEventListener('focus', ()=>{ state.activeRoomIndex = i; render(); });

      const subInput = document.createElement('input');
      subInput.type = 'text'; subInput.className = 'ss-room-sub'; subInput.maxLength = 26;
      subInput.placeholder = 'Hours (optional)'; subInput.value = room.roomSub;
      subInput.addEventListener('input', e=>{ room.roomSub = e.target.value; render(); });
      subInput.addEventListener('focus', ()=>{ state.activeRoomIndex = i; render(); });

      const removeBtn = document.createElement('button');
      removeBtn.type = 'button'; removeBtn.className = 'ss-room-remove';
      removeBtn.textContent = '×'; removeBtn.setAttribute('aria-label', 'Remove room');
      removeBtn.addEventListener('click', ()=>{
        state.rooms.splice(i, 1);
        if (state.activeRoomIndex >= state.rooms.length) state.activeRoomIndex = Math.max(0, state.rooms.length-1);
        render();
      });

      row.appendChild(numInput);
      row.appendChild(subInput);
      row.appendChild(removeBtn);
      return row;
    }

    // One room per line. Fields can be separated by commas or tabs (tabs so a
    // column pasted straight out of Excel/Sheets works with no reformatting):
    //   Fitness Center, 6:00 AM - 10:00 PM
    //   Pool
    //   Business Center	Open 24 Hours
    function parseBulkPaste(text){
      return String(text||'').split(/\r?\n/).map(l=>l.trim()).filter(Boolean).map(line=>{
        const fields = line.indexOf('\t') !== -1 ? line.split('\t') : line.split(',');
        const roomText = (fields[0]||'').trim();
        const roomSub = (fields[1]||'').trim();
        return { roomText, roomSub };
      }).filter(r => r.roomText);
    }

    function bindBulkControls(){
      const pasteEl = root.querySelector('#cr-bulkPaste');
      const addFromListBtn = root.querySelector('#cr-bulkAddBtn');
      const addRowBtn = root.querySelector('#cr-bulkAddRowBtn');
      const clearBtn = root.querySelector('#cr-bulkClearBtn');

      if (addFromListBtn) addFromListBtn.addEventListener('click', ()=>{
        const parsed = parseBulkPaste(pasteEl.value);
        if (!parsed.length) return;
        const startIndex = state.rooms.length;
        state.rooms = state.rooms.concat(parsed);
        state.activeRoomIndex = startIndex;
        pasteEl.value = '';
        render();
      });

      if (addRowBtn) addRowBtn.addEventListener('click', ()=>{
        state.rooms.push({ roomText:'', roomSub:'' });
        state.activeRoomIndex = state.rooms.length - 1;
        render();
      });

      if (clearBtn) clearBtn.addEventListener('click', ()=>{
        if (!state.rooms.length) return;
        state.rooms = [];
        state.activeRoomIndex = 0;
        render();
      });
    }

    function render(){
      // Auto-suggest room name/hours when the template changes, unless the
      // customer has typed their own — must run first, before anything else
      // in render() reads state, so a template switch takes effect the same
      // pass instead of one interaction late.
      if (state.template !== lastTemplate){
        const t = TEMPLATES[state.template];
        if (!state.roomTextManual) state.roomText = t.roomText;
        if (!state.roomSubManual) state.roomSub = t.roomSub;
        lastTemplate = state.template;
      }

      const shapeName = state.shape;
      if (ACCENTS[state.accent].incompatibleShapes && ACCENTS[state.accent].incompatibleShapes.includes(shapeName)){
        state.accent = 'none';
      }
      // Backplate is sold as the "Offset Shadow" accent — picking that look IS
      // the paid backplate add-on, so Material (which is what actually prices
      // the variant) tracks the accent choice rather than being picked
      // separately. This only works because there's one thickness (1/8")
      // in play; if a second thickness returns, Material needs to encode
      // both thickness and backplate again.
      state.material = (state.accent==='shadow') ? 'backplate' : 'standard';
      // Every sign we sell is ADA-compliant now — no toggle, no non-compliant
      // option. Typeface is locked to sans-serif per §703.2.2.
      if (state.typeface!=='sans'){
        state.typeface = 'sans';
      }

      const size = SIZES[state.size];
      const typeface = TYPEFACES[state.typeface];
      const plateW = 320, plateH = plateW * (size.h/size.w);
      const vbW = plateW+120, vbH = plateH+120;
      const px = (vbW-plateW)/2, py = (vbH-plateH)/2;
      const uid = state.material;
      const clipId = 'clip-' + sectionId + '-' + uid;

      let defs = materialFillDefs(uid, state.plateColor);
      const plateFill = `url(#fill-${uid})`;
      const overlay = '';
      defs += `<clipPath id="${clipId}">${shapeMarkup(shapeName, px, py, plateW, plateH, '', 6)}</clipPath>`;

      let standoffs = '';
      if (state.mounting==='standoff'){
        standoffs = standoffPoints(shapeName, px, py, plateW, plateH)
          .map(([cx,cy])=>`<circle cx="${cx}" cy="${cy}" r="5" fill="#8E7442"/><circle cx="${cx}" cy="${cy}" r="2" fill="#C6A05F"/>`).join('');
      }
      const glow = '';

      if (!state.textColorManual){
        state.textColor = MATERIALS[state.material].engrave;
      }
      const engraveColor = state.textColor;
      // Both current materials are acrylic (just different thickness), so the
      // lighter stroke always applies — revisit if a non-acrylic option is added.
      const plateStroke = 'rgba(255,255,255,0.6)';
      const plateShadow = shadowFilter(state.mounting);

      // ---- accent overlays: offset shadow draws BEHIND the plate; the rest draw
      // on top, clipped to the plate's own outline so nothing spills past the edge ----
      const accentColorValue = accentColorHex();
      const shadowBehindMarkup = state.accent==='shadow'
        ? offsetShadowMarkup(shapeName, px, py, plateW, plateH, accentColorValue) : '';
      const onTopAccentMarkup = (state.accent!=='none' && state.accent!=='shadow')
        ? accentOverlayMarkup(state.accent, px, py, plateW, plateH, accentColorValue) : '';

      const textColor = engraveColor;
      const activeRoom = getActiveRoom();

      const roomTextDisplay = activeRoom.roomText.toUpperCase();

      // stripe/bands accents carve out dedicated space, so keep text clear
      // of those zones rather than centering over them
      // Each non-rectangular shape cuts into the plate differently — a flat
      // 0% margin only works for shapes with straight full-height sides.
      // Arch's dome narrows above ~24% of height, Wavy pinches in ~14.4% of
      // width at the vertical middle, Bowed's left edge bows in from ~9% of
      // width, and Diagonal slices off a corner — each needs its own
      // clearance instead of one flat margin, or text sits on top of the
      // curve/cut instead of inside the plate.
      const SIDE_MARGIN = { rectangle:0, oval:0.06, arch:0, wavy:0.15, bowed:0.11, diagonal:0 };
      const TOP_MARGIN  = { arch:0.26 };
      const sideMargin = SIDE_MARGIN[shapeName] ?? 0;
      const minTopFrac = TOP_MARGIN[shapeName] || 0;

      const hasStripe = state.accent==='stripe';
      const hasBands = state.accent==='bands';
      const contentLeft = px + plateW*(hasStripe ? Math.max(0.16, sideMargin) : sideMargin);
      const contentRight = px + plateW*(1-sideMargin);
      const contentTop = py + plateH*(minTopFrac + (hasBands ? 0.15 : 0));
      const contentBottom = py + plateH - (hasBands ? plateH*0.15 : 0);
      const usableH = contentBottom - contentTop;

      const textZoneWidth = contentRight - contentLeft;
      const cx = contentLeft + textZoneWidth/2;

      const subFontSize = plateH*0.10;
      // Real measurement (not a char-count guess) — this is what actually
      // guarantees a long name like "Business Center" can never run past
      // the plate edge, regardless of typeface or which characters it uses.
      const availableTextWidth = textZoneWidth * 0.92;
      const roomFontSize = fitFontSizeByMeasurement(roomTextDisplay, availableTextWidth, plateH*0.30, 10, typeface.family, typeface.weight);

      // Name, optional Hours (its own bold label line + value line, not just
      // a plain sub-label), and braille stack vertically within the text zone.
      let numY, hoursLabelY, hoursValueY, brailleY;
      if (activeRoom.roomSub){
        numY = contentTop + usableH*0.30;
        hoursLabelY = contentTop + usableH*0.47;
        hoursValueY = contentTop + usableH*0.60;
        brailleY = contentTop + usableH*0.76;
      } else {
        numY = contentTop + usableH*0.38;
        brailleY = contentTop + usableH*0.62;
      }

      // Real physical scale: plateW px corresponds to size.w inches, so braille
      // dots can be sized to the actual ADA-spec tolerances (§703.3) rather than
      // an arbitrary proportion of the plate — dot diameter ~0.06", dot-to-dot
      // spacing ~0.09", cell-to-cell spacing ~0.27" (mid-range of the spec).
      // Preset alignment (not freeform positioning) — bounded so a customer
      // can change where text sits without overlapping anything else.
      // Center alignment gets implicit margin from the width-fit calculation
      // (text is sized to 92% of the zone), but Left/Right anchor directly at
      // the zone boundary — which, for a Rectangle plate, IS the physical
      // plate edge — so they need their own explicit inset or the text
      // clips against the edge/rounded corner.
      const alignInset = textZoneWidth * 0.04;
      function alignX(align){
        if (align==='left') return contentLeft + alignInset;
        if (align==='right') return contentRight - alignInset;
        return cx;
      }
      function anchorFor(align){
        if (align==='left') return 'start';
        if (align==='right') return 'end';
        return 'middle';
      }

      const pxPerInch = plateW / size.w;
      const brailleDotR = 0.0615/2 * pxPerInch;
      const brailleDotGap = 0.0925 * pxPerInch;
      const brailleCellGap = 0.2705 * pxPerInch;

      const roomTextAlignX = alignX(state.roomTextAlign);
      const roomTextAnchor = anchorFor(state.roomTextAlign);
      const roomSubAlignX = alignX(state.roomSubAlign);
      const roomSubAnchor = anchorFor(state.roomSubAlign);

      const content = `
        <text x="${roomTextAlignX}" y="${numY}" text-anchor="${roomTextAnchor}" font-family="${typeface.family}" font-weight="${typeface.weight}" font-style="${typeface.italic?'italic':'normal'}" font-size="${roomFontSize}" fill="${textColor}">${escapeXml(roomTextDisplay)}</text>
        ${activeRoom.roomSub ? `
          <text x="${roomSubAlignX}" y="${hoursLabelY}" font-family="-apple-system,sans-serif" font-weight="700" letter-spacing="1.5" text-anchor="${roomSubAnchor}" font-size="${subFontSize*0.8}" fill="${textColor}" opacity="0.65">HOURS</text>
          <text x="${roomSubAlignX}" y="${hoursValueY}" font-family="-apple-system,sans-serif" font-weight="600" text-anchor="${roomSubAnchor}" font-size="${subFontSize*1.05}" fill="${textColor}" opacity="0.9">${escapeXml(activeRoom.roomSub)}</text>
        ` : ''}
        ${activeRoom.roomText ? brailleMarkup(activeRoom.roomText, cx, brailleY, textColor, brailleDotR, brailleDotGap, brailleCellGap) : ''}
      `;

      const svg = `
        <svg viewBox="0 0 ${vbW} ${vbH}" width="${vbW}" height="${vbH}" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Room number sign preview">
          <defs>${defs}</defs>
          ${glow}
          ${shadowBehindMarkup}
          ${shapeMarkup(shapeName, px, py, plateW, plateH, `fill="${plateFill}" style="${plateShadow}" stroke="${plateStroke}" stroke-width="1"`, 6)}
          ${overlay}
          <g clip-path="url(#${clipId})">${onTopAccentMarkup}</g>
          ${standoffs}
          ${content}
        </svg>`;

      const stage = document.getElementById('cr-stage');
      let holder = stage.querySelector('.ss-svg-holder');
      if (!holder){
        holder = document.createElement('div');
        holder.className = 'ss-svg-holder';
        stage.insertBefore(holder, stage.querySelector('.cr-stage-caption'));
      }
      holder.innerHTML = svg;

      document.getElementById('cr-stage-dims').textContent = `${size.w}" × ${size.h}" — Common Room`;
      document.getElementById('cr-stage-mount').textContent = MOUNTINGS[state.mounting].label;
      const stageRoomEl = document.getElementById('cr-stage-room');
      if (stageRoomEl){
        stageRoomEl.textContent = (state.mode==='bulk' && state.rooms.length)
          ? `Previewing Room ${activeRoom.roomText || (state.activeRoomIndex+1)} of ${state.rooms.length}`
          : '';
      }

      root.querySelector('#cr-customColorFields').style.display = '';
      const textColorEl = root.querySelector('#cr-textColor');
      if (textColorEl && document.activeElement !== textColorEl) textColorEl.value = state.textColor;
      const roomTextEl = root.querySelector('#cr-roomText');
      if (roomTextEl && document.activeElement !== roomTextEl) roomTextEl.value = state.roomText;
      const roomSubEl = root.querySelector('#cr-roomSub');
      if (roomSubEl && document.activeElement !== roomSubEl) roomSubEl.value = state.roomSub;

      buildChipRow(root.querySelector('#cr-modeRow'), { single:{label:'Single Sign'}, bulk:{label:'Bulk Order'} }, 'mode');
      const singleSection = root.querySelector('#cr-singleSection');
      const bulkSection = root.querySelector('#cr-bulkSection');
      if (singleSection) singleSection.style.display = (state.mode==='single') ? '' : 'none';
      if (bulkSection) bulkSection.style.display = (state.mode==='bulk') ? '' : 'none';
      if (state.mode==='bulk') buildRoomsTable(root.querySelector('#cr-roomsTable'));
      const roomCountEl = root.querySelector('#cr-roomCount');
      if (roomCountEl) roomCountEl.textContent = state.rooms.length;

      buildChipRow(root.querySelector('#cr-templateRow'), TEMPLATES, 'template');
      buildChipRow(root.querySelector('#cr-hoursToggleRow'), HOURS_MODES, 'hoursMode');
      const hoursInput = root.querySelector('#cr-roomSub');
      if (hoursInput) hoursInput.style.display = (state.hoursMode==='with') ? '' : 'none';

      buildChipRow(root.querySelector('#cr-roomTextAlignRow'), ALIGNMENTS, 'roomTextAlign');
      buildChipRow(root.querySelector('#cr-roomSubAlignRow'), ALIGNMENTS, 'roomSubAlign');

      buildChipRow(root.querySelector('#cr-shapeRow'), SHAPES, 'shape');
      buildChipRow(root.querySelector('#cr-typefaceRow'), TYPEFACES, 'typeface', (k)=>{
        return k!=='sans';
      });
      buildChipRow(root.querySelector('#cr-sizeRow'), SIZES, 'size');
      buildChipRow(root.querySelector('#cr-mountingRow'), MOUNTINGS, 'mounting');
      buildChipRow(root.querySelector('#cr-accentRow'), ACCENTS, 'accent', (k,opt)=>{
        return !!(opt.incompatibleShapes && opt.incompatibleShapes.includes(shapeName));
      });
      const showAccentColor = ACCENTS[state.accent].needsColor;
      root.querySelector('#cr-accentColorField').style.display = showAccentColor ? '' : 'none';
      if (showAccentColor){
        buildChipRow(root.querySelector('#cr-accentColorRow'), ACCENT_COLORS, 'accentColor');
        root.querySelector('#cr-accentCustomColorField').style.display = (state.accentColor==='custom') ? '' : 'none';
      }

      // ---- ADA compliance is now standard on every sign, so nothing about
      // it is surfaced to the customer. Contrast still gets computed here
      // (silently) rather than deleted outright, in case a low-contrast
      // flag is wanted somewhere later — it just never reaches the DOM. ----
      const contrastPass = contrastRatio(state.textColor, state.plateColor) >= 4.5;
      const complianceEl = root.querySelector('#cr-complianceCheck');
      if (complianceEl) complianceEl.style.display = 'none';

      // ---- price from the matched real Shopify variant ----
      const variant = findVariant();
      const priceEl = document.getElementById('cr-priceValue');
      const unavailableEl = document.getElementById('cr-unavailable');
      const addBtn = document.getElementById('cr-addBtn');
      const validRoomCount = state.mode==='bulk' ? state.rooms.filter(r=>r.roomText.trim()).length : 1;

      if (variant){
        if (state.mode==='bulk'){
          priceEl.textContent = validRoomCount
            ? `${variant.price} × ${validRoomCount} = ${formatTotal(variant.price, validRoomCount)}`
            : variant.price;
        } else {
          priceEl.textContent = variant.price;
        }
        if (!variant.available){
          unavailableEl.textContent = 'This combination is currently out of stock.';
          unavailableEl.style.display = '';
          addBtn.disabled = true;
        } else if (state.mode==='bulk' && validRoomCount===0){
          unavailableEl.textContent = 'Add at least one room name to this order first.';
          unavailableEl.style.display = '';
          addBtn.disabled = true;
        } else {
          unavailableEl.style.display = 'none';
          addBtn.disabled = false;
        }
      } else {
        priceEl.textContent = '—';
        unavailableEl.textContent = "This exact combination isn't available yet — try a different size or mounting.";
        unavailableEl.style.display = '';
        addBtn.disabled = true;
      }
      addBtn.textContent = (state.mode==='bulk') ? `Add All to Cart (${validRoomCount})` : 'Add to cart';
    }

    function formatTotal(unitPriceStr, count){
      const match = String(unitPriceStr).match(/^([^\d]*)([\d,.]+)/);
      if (!match) return unitPriceStr;
      const prefix = match[1];
      const num = parseFloat(match[2].replace(/,/g,'')) || 0;
      return prefix + (num * count).toFixed(2);
    }

    function bindTextInputs(){
      const roomTextEl = root.querySelector('#cr-roomText');
      if (roomTextEl){
        roomTextEl.value = state.roomText;
        roomTextEl.addEventListener('input', e=>{
          state.roomText = e.target.value;
          state.roomTextManual = true;
          render();
        });
      }
      const roomSubEl = root.querySelector('#cr-roomSub');
      if (roomSubEl){
        roomSubEl.value = state.roomSub;
        roomSubEl.addEventListener('input', e=>{
          state.roomSub = e.target.value;
          state.roomSubManual = true;
          render();
        });
      }
      [['cr-plateColor','plateColor'],
       ['cr-accentCustomColor','accentCustomColor']].forEach(([id,key])=>{
        const el = root.querySelector('#'+id);
        if (!el) return;
        el.value = state[key];
        el.addEventListener('input', e=>{ state[key] = e.target.value; render(); });
      });
      const textColorEl = root.querySelector('#cr-textColor');
      if (textColorEl){
        textColorEl.value = state.textColor;
        textColorEl.addEventListener('input', e=>{
          state.textColor = e.target.value;
          state.textColorManual = true;
          render();
        });
      }
    }

    function buildSharedProperties(){
      const properties = {
        'Shape': SHAPES[state.shape].label,
        'Typeface': TYPEFACES[state.typeface].label
      };
      if (state.accent!=='none'){
        properties['Accent Style'] = ACCENTS[state.accent].label;
        properties['Accent Color'] = state.accentColor==='custom' ? state.accentCustomColor : ACCENT_COLORS[state.accentColor].label;
      }
      properties['Shape Color'] = state.plateColor;
      properties['Text Color'] = state.textColor;
      return properties;
    }

    function addToCart(){
      const variant = findVariant();
      if (!variant || !variant.available){ return; }
      const errorEl = document.getElementById('cr-error');
      const addBtn = document.getElementById('cr-addBtn');

      let items;
      if (state.mode==='bulk'){
        const validRooms = state.rooms.filter(r=>r.roomText.trim());
        if (!validRooms.length) return;
        items = validRooms.map(room=>{
          const properties = Object.assign(
            { 'Room Name': room.roomSub ? (room.roomText + ' — ' + room.roomSub) : room.roomText },
            buildSharedProperties()
          );
          return { id: variant.id, quantity: 1, properties: properties };
        });
      } else {
        const properties = Object.assign(
          { 'Room Name': state.roomSub ? (state.roomText + ' — ' + state.roomSub) : state.roomText },
          buildSharedProperties()
        );
        items = [{ id: variant.id, quantity: 1, properties: properties }];
      }

      errorEl.style.display = 'none';
      addBtn.disabled = true;
      const originalLabel = addBtn.textContent;
      addBtn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(res => res.json().then(body => ({ ok: res.ok, body })))
      .then(({ ok, body })=>{
        addBtn.disabled = false;
        if (!ok){
          errorEl.textContent = (body && body.description) || 'Could not add this to your cart. Please try again.';
          errorEl.style.display = '';
          addBtn.textContent = originalLabel;
          return;
        }
        addBtn.textContent = (state.mode==='bulk') ? `Added ${items.length} ✓` : 'Added ✓';
        addBtn.classList.add('ss-added');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: body } }));
        if (state.mode==='bulk'){
          // clear the batch after a successful add so the same rooms can't
          // accidentally get submitted twice
          state.rooms = [];
          state.activeRoomIndex = 0;
        }
        setTimeout(()=>{
          addBtn.classList.remove('ss-added');
          render();
        }, 1800);
      })
      .catch(()=>{
        addBtn.disabled = false;
        addBtn.textContent = originalLabel;
        errorEl.textContent = 'Network error — please try again.';
        errorEl.style.display = '';
      });
    }

    root.querySelector('#cr-addBtn').addEventListener('click', addToCart);

    bindTextInputs();
    bindBulkControls();
    render();
    materialImagesReady.then(render);
  }
})();
